// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"1651857a","117":"0772112d","145":"f5234060"}[chunkId] + ".chunk.css";
};